import { PaginatedResponse, Review } from "@cabukaka/types"
import { dataService } from "./core/dataService"
import { getConfig } from "@cabukaka/config/index";
import axios from "axios";

export const reviewService = {
    get baseService() {
        return dataService<Review>("reviews");
    },

    getReviewsByShopId: async (shopId: string, token?: string): Promise<PaginatedResponse<Review>> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<PaginatedResponse<Review>>(`${apiUrl}/reviews/shop/${shopId}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return res.data;
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },

    getReviewsByProductId: async (productId: string, token?: string): Promise<PaginatedResponse<Review>> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<PaginatedResponse<Review>>(`${apiUrl}/reviews/product/${productId}`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return res.data;
        } catch (error) {
            console.error(error);
            return { data: [], total: 0, pages: 0 };
        }
    },

    // Tape sur l'endpoint des stats de la boutique
    getShopStats: async (shopId: string, token?: string): Promise<{ rating: number; reviews: number }> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<{ rating: number; reviews: number }>(`${apiUrl}/reviews/shop/${shopId}/stats`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return res.data;
        } catch (error) {
            console.error(error);
            return { rating: 0, reviews: 0 };
        }
    },

    // Ajout harmonisé : Tape sur le nouvel endpoint des stats du produit
    getProductStats: async (productId: string, token?: string): Promise<{ rating: number; reviews: number }> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.get<{ rating: number; reviews: number }>(`${apiUrl}/reviews/product/${productId}/stats`, {
                headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            return res.data;
        } catch (error) {
            console.error(error);
            return { rating: 0, reviews: 0 };
        }
    },
}